import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  get offerDetails() {
    return this.element.querySelector("div[data-element='details']");
  }

  get offerDetailsButtons() {
    return Array.from(this.element.querySelectorAll('button[data-show-text]'));
  }

  details(event) {
    const tab = event.target.dataset.showTab && `#${event.target.dataset.showTab}`;

    const tabChanged = tab != window.location.hash;
    const detailsHidden = this.offerDetails.classList.contains('hidden');

    history.replaceState(null, null, tab);

    this.setTab(tab);

    if (tabChanged && !detailsHidden && !event.target.dataset.forceToggle) return;
    this.toggleOfferDetails(tab);
  }

  scrollIntoView() {
    // Don't even bother if we're dealing with IE
    if (window.document.documentMode) return;

    if (!this.offerDetails.classList.contains('hidden')) {
      const scrollTo = this.offerDetails.querySelector('[data-scroll-to="true"]');
      if (scrollTo) scrollTo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  toggleButtonText() {
    this.offerDetailsButtons.forEach(btn => {
      if (btn.innerHTML === btn.dataset.showText) {
        btn.innerHTML = btn.dataset.hideText;
      } else {
        btn.innerHTML = btn.dataset.showText;
      }
    });
  }

  toggleOfferDetails() {
    if (this.offerDetails.innerHTML === '') {
      this.displaySpinner();
      this.fetchOfferDetails();
    } else {
      this.toggleButtonText();
      this.offerDetails.classList.toggle('hidden');
      this.scrollIntoView();
    }
  }

  displaySpinner() {
    this.offerDetails.innerHTML = this.offerDetails.dataset.spinner.replace(/\\/g, '');
    this.offerDetails.classList.toggle('hidden');
    this.toggleButtonText();
  }

  fetchOfferDetails() {
    this.offerDetailsButtons.forEach(btn => btn.setAttribute('disabled', 'disabled'));

    fetch(this.data.get('url'))
      .then(response => response.text())
      .then(html => {
        this.offerDetails.innerHTML = html;
        this.offerDetailsButtons.forEach(btn => btn.removeAttribute('disabled', 'disabled'));
        this.scrollIntoView();
      });
  }

  setTab(tab) {
    if (this.tabController) this.tabController.setTab(tab);
  }

  get tabController() {
    const tabElement = this.element.querySelector('[data-controller="tabs"]');
    if (!tabElement) return;

    return this.application.getControllerForElementAndIdentifier(tabElement, 'tabs');
  }
}
